import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'SprayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spray",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 10m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 7h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 9h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 5h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 3h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 7h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 11h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 7h1"
    }, null), _createTextVNode(" ")]);
  }
};